import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import ContactUsApp from '@/contact-us/ContactUsApp';
import i18n from '@/i18n';
import { CmsProvider } from '@/context/cms';

document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById('js-r-entry-contact-us');
  // load specific namespace for contact-us section
  i18n.loadNamespaces('contact-us', () => {
    ReactDOM.render(
      <I18nextProvider i18n={i18n}>
        <Suspense fallback={<div />}>
          <CmsProvider>
            <ContactUsApp {...el.dataset} />
          </CmsProvider>
        </Suspense>
      </I18nextProvider>,
      el,
    );
  });
});
